import { useMutation } from "react-query";
import { useAppContext } from "../AppProviders";
import { ATSListInputApi, ATSItem } from "./ATS";
import { API_URL } from "./helpers";

export function useGetATSList() {
  const { requestApi } = useAppContext();
  const getATSList = async (input: ATSListInputApi): Promise<ATSItem[]> => {
    return requestApi
      .get(`${API_URL}/integrations/${input.company}`)
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (input: ATSListInputApi) => getATSList(input),
    {}
  );

  return {
    ...mutationResult,
  };
}

export function useCreateATSIntegration() {
  const { requestApi } = useAppContext();

  const createATSIntegration = async (input: {
    company_external_id: string;
    integration_tool: string;
  }) => {
    return requestApi
      .post(`${API_URL}/actorservice/ats/`, input)
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (input: { company_external_id: string; integration_tool: string }) =>
      createATSIntegration(input),
    {}
  );

  return {
    ...mutationResult,
  };
}

export function useDeleteATSIntegration() {
  const { requestApi } = useAppContext();

  const deleteATSIntegration = async (id: string) => {
    return requestApi
      .delete(`${API_URL}/actorservice/ats/${id}`)
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (id: string) => deleteATSIntegration(id),
    {}
  );

  return {
    ...mutationResult,
  };
}
